// extracted by mini-css-extract-plugin
export default {"vipCardsContainer":"VipCards_vipCardsContainer__16ICJ","header":"VipCards_header__fz7J1"};